/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Execution_Type_Distance_RangeInputs */

const fr_execution_type_distance_range = /** @type {(inputs: Execution_Type_Distance_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plage de distance (m)`)
};

/**

* @param {Execution_Type_Distance_RangeInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const execution_type_distance_range = /** @type {((inputs?: Execution_Type_Distance_RangeInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Execution_Type_Distance_RangeInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_execution_type_distance_range(inputs)
});